module.exports = __webpack_public_path__ + "static/media/ajax-Loader.943fc0ba.gif";